var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.$route.meta.isBreadcrumb)?_c('Breadcrumb'):_vm._e(),_c('div',{staticClass:"content-wrap"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }